import React, { FC } from 'react';
import { useContentfulInspectorMode } from '@contentful/live-preview/react';
import Image from 'src/components/Image';
import styles from './Header.module.scss';

interface Props {
  src?: string;
  alt?: string;
  entryId?: string;
}

const Header: FC<Props> = ({ src, alt, entryId }) => {
  const inspectorProps = useContentfulInspectorMode({ entryId });
  return src ? (
    <Image
      className={styles.header}
      src={src}
      alt={alt}
      isLazy={false}
      {...inspectorProps({ fieldId: 'bannerImage' })}
    />
  ) : (
    <div
      className={styles.default}
      {...inspectorProps({ fieldId: 'bannerImage' })}
    />
  );
};

export default Header;
